import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import Transition from "../../stateless/Transition";
import styles from "../../../styles/global-styles";
import { SiteService } from "../../../services/site.service";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  formControl: styles.globalFormControl,
}));

const AddSite = ({ onClose, open, siteCreated }) => {
  const classes = useStyles();
  const [newSite, setNewSite] = useState({});

  const handleClose = () => onClose();

  const handleSubmitForm = async () => {
    console.log("site values", newSite);
    try {
      const result = await SiteService.postSite(newSite);
      console.log("result update", result);
      if (result.status === 201) {
        siteCreated(true);
      }
    } catch (error) {
      console.log("error POST site", error);
      siteCreated(false);
    }
    onClose();
  };

  const handleInputText = ({ target: { name, value } }) => {
    setNewSite({ ...newSite, [name]: value });
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"md"}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Agregar sucursal
      </DialogTitle>
      <DialogContent>
        <ValidatorForm
          noValidate
          className={classes.form}
          method="POST"
          onSubmit={handleSubmitForm}
          onError={(errors) => console.log(errors)}
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="center"
          >
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Typography variant="body2" className={classes.label}>
                Nombre
              </Typography>
              <TextValidator
                className={classes.inputField}
                name="name"
                value={newSite.name || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["El nombre es requerido"]}
                variant="outlined"
                inputProps={{
                  maxLength: 50,
                }}
              ></TextValidator>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Typography variant="body2" className={classes.label}>
                Dirección
              </Typography>
              <TextValidator
                className={classes.inputField}
                name="direction"
                value={newSite.direction || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["La dirección es requerida"]}
                variant="outlined"
                inputProps={{
                  maxLength: 150,
                }}
              ></TextValidator>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={5}
              xl={5}
              style={{ marginTop: 30 }}
            >
              <Typography variant="body2" className={classes.label}>
                CP
              </Typography>
              <TextValidator
                className={classes.inputField}
                name="cp"
                value={newSite.cp || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["El C.P. es requerido"]}
                variant="outlined"
                inputProps={{
                  maxLength: 5,
                }}
              ></TextValidator>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={5}
              xl={5}
              style={{ marginTop: 30 }}
            >
              <Typography variant="body2" className={classes.label}>
                Serie para facturar
              </Typography>
              <TextValidator
                className={classes.inputField}
                name="serie"
                value={newSite.serie || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["La serie es requerida"]}
                variant="outlined"
                inputProps={{
                  maxLength: 2,
                }}
              ></TextValidator>
            </Grid>

            <Grid
              style={{ marginTop: 40 }}
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Button
                  color="primary"
                  style={{ marginRight: 50, width: 150 }}
                  onClick={() => onClose()}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  style={{ width: 150 }}
                  variant="contained"
                  type="submit"
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};

export default AddSite;
